import React, { PropsWithChildren } from 'react';

import { cn } from '@/utils/cn';

interface StackedCardProps {
    className?: string;
    /** Renders the two-layer "stacked cards behind" shadow. Off for card types that shouldn't imply a collection. */
    stacked?: boolean;
}

const STACK_SHADOW =
    '4px 4px 0 0 #fff, 4px 4px 0 1px rgb(206,202,198), 8px 8px 0 0 #fff, 8px 8px 0 1px rgb(206,202,198)';

export const StackedCard: React.FC<PropsWithChildren<StackedCardProps>> = ({ children, className, stacked = true }) => (
    <div
        className={cn('border-cocoa-200 flex h-full flex-col rounded-lg border bg-white p-5', className)}
        style={{ boxShadow: stacked ? STACK_SHADOW : undefined }}
    >
        {children}
    </div>
);
